export const locations ={
  "hel-pu": "Puck",	
  "hel-ku": "Kuźnica",	
  "hel-ja": "Jastarnia",
  "hel-jg": "Jatrzębia Góra",	
  "hl-ja": "hl-ja",
}